import { FilterProtocolDTO } from "./filterProtocolDTO";

export class FilterDefinitionDTO{

    public id? : number;
    public name! : string;
    public description! : string;
    public fileDefinitionId! : number;
    public filterProtocols : FilterProtocolDTO[] = [];
    public version? : number; //incremental version number set by server
    public published : boolean = false; //if true, then can be used for moovs and can be loaded by other users
    public added? : string;
    public deleted : boolean = false;
    public ownedByEntityId?: number;
    public ownerEntityType?: string;
    public wizardSessionId?: number;

    constructor(){

    }
}